import React from "react";
import KA from '../assets/KA.png';
import HP from '../assets/HP.png';
import VDI from '../assets/VDI.png';
// Served from /public so index.html can preload them (LCP images)
const heroBgDesktop = '/hero/ZDI.webp';
const heroBgMobile = '/hero/ZDI-mobile.webp';
// import confetti from "canvas-confetti";
// import { useEffect } from "react";

function HeroSection({ setViewModal, setViewModal2 }) {
    // 🎉 Trigger confetti on mount
  // useEffect(() => {
  //   var count = 200;
  //   var defaults = {
  //     origin: { y: 0.7 }
  //   };

  //   function fire(particleRatio, opts) {
  //     confetti({
  //       ...defaults,
  //       ...opts,
  //       particleCount: Math.floor(count * particleRatio)
  //     });
  //   }

  //   // 🎉 Multi-stage cinematic burst
  //   fire(0.25, {
  //     spread: 26,
  //     startVelocity: 55,
  //   });

  //   fire(0.2, {
  //     spread: 60,
  //   });

  //   fire(0.35, {
  //     spread: 100,
  //     decay: 0.91,
  //     scalar: 0.8,
  //   });

  //   fire(0.1, {
  //     spread: 120,
  //     startVelocity: 25,
  //     decay: 0.92,
  //     scalar: 1.2,
  //   });

  //   fire(0.1, {
  //     spread: 120,
  //     startVelocity: 45,
  //   });

  // }, []);


  return (
    <section className="relative bg-[#f9f8fd] text-gray-900 pt-2 md:pt-12 lg:pt-16 pb-4 md:pb-20 px-6 md:px-12 lg:px-20 overflow-hidden">
      {/* ✅ Full Background Image (Desktop) */}
      <div
        className="hidden md:block absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBgDesktop})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>

      {/* ✅ Full Background Image (Mobile) */}
      <div
        className="block md:hidden absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${heroBgMobile})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>

      {/* GRADIENT */}
      <div
        className="absolute bottom-0 left-0 w-full h-2 z-10 pointer-events-none"
        style={{
          background:
            "linear-gradient(to top, #f9f8fd 0%, rgba(249,248,253,0.75) 35%, rgba(249,248,253,0.35) 60%, rgba(249,248,253,0) 100%)",
        }}
      />

      {/* Content Section */}
      <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 z-20">
        
        {/* Left Section (60% width on desktop) */}
        <div className="flex-[0.6] text-left space-y-6 order-1 md:order-1">
          <h1 className="text-[38px] text-[#151595] sm:text-4xl lg:text-[38px] font-semibold leading-tight">
            Kannada's <span className="text-[#151595]">No.1 Tech Skilling Platform</span>
          </h1>
          <p className="text-2xl sm:text-xl lg:text-3xl font-semibold">
            Master Cloud, DevOps, GenAI & Transition into{" "}
            <span className="font-semibold">4X Salary Roles</span>
          </p>

          {/* Skills */}
          <div className="hidden md:block mt-0 2xl:!mt-12">
            <p className="hidden md:block text-lg sm:text-xl lg:text-2xl text-gray-800 font-medium mb-2">
              Skills Covered
            </p>

            {/* ✅ Mobile View (3 rows) */}
            <div className="block md:hidden space-y-2 mb-5">
              {/* Row 1 */}
              <div className="flex flex-wrap gap-2">
                {["AWS", "Azure", ].map((skill) => (
                  <span
                    key={skill}
                    className="inline-flex items-center rounded-2xl bg-gray-100 px-3 py-1 font-semibold text-blue-700 text-sm ring-1 ring-inset ring-blue-700/10 backdrop-blur-sm"
                  >
                    {skill}
                  </span>
                ))}
              </div>
              {/* Row 2 */}
              <div className="flex flex-wrap gap-2">
                {["Linux", "DevOps", "CI/CD"].map((skill) => (
                  <span
                    key={skill}
                    className="inline-flex items-center rounded-2xl bg-gray-100 px-3 py-1 font-semibold text-blue-700 text-sm ring-1 ring-inset ring-blue-700/10 backdrop-blur-sm"
                  >
                    {skill}
                  </span>
                ))}
              </div>
              {/* Row 3 */}
              <div className="flex flex-wrap gap-2">
                {["DevSecOps", "CKA", "GenAI", "+More"].map((skill) => (
                  <span
                    key={skill}
                    className={`inline-flex items-center rounded-2xl bg-gray-100 px-3 py-1 text-sm ${
                      skill === "+More"
                        ? "font-bold text-blue-700 ring-1 ring-inset ring-blue-700/10"
                        : "font-semibold text-blue-700 ring-1 ring-inset ring-blue-700/10"
                    } backdrop-blur-sm`}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>

            {/* ✅ Desktop View */}
            <div className="hidden md:flex flex-wrap gap-2 mb-5">
              {["GenAI", "CKA", "GCP", "MLOps","AWS", "Azure", "Networking", "Linux", "DevOps", "CI/CD", "DevSecOps", "+More"].map(
                (skill) => (
                  <span
                    key={skill}
                    className={`inline-flex items-center rounded-2xl bg-gray-100 px-3 py-1 text-base ${
                      skill === "+More"
                        ? "font-bold text-blue-700 ring-1 ring-inset ring-blue-700/10"
                        : "font-semibold text-blue-700 ring-1 ring-inset ring-blue-700/10"
                    } backdrop-blur-sm`}
                  >
                    {skill}
                  </span>
                )
              )}
            </div>
          </div>

          {/* ✅ Mobile spacer — reveals the person's face in the background */}
          <div className="block md:hidden h-80"></div>

          {/* CTA Buttons */}
          <div className="
  flex flex-col sm:flex-row
  gap-4
  justify-start
  -mt-8 sm:mt-6   /* ⬆️ MOBILE: pull buttons UP */
  2xl:!mt-14    /* ↕️ 2XL: extra gap after Skills Covered */
">
            {/* Download Curriculum */}
            <button
              onClick={() => setViewModal2(true)}
              className="mt-5 md:mt-0 flex items-center justify-center gap-2 bg-[#FF0049] text-white font-semibold px-6 py-3 rounded-lg shadow-md hover:shadow-lg hover:bg-[#FF0049] transition transform hover:scale-105 shadow-red-600/50"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" className="w-6 h-6 fill-current">
                <path d="M320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64zM308.7 451.3L204.7 347.3C200.1 342.7 198.8 335.8 201.2 329.9C203.6 324 209.5 320 216 320L272 320L272 224C272 206.3 286.3 192 304 192L336 192C353.7 192 368 206.3 368 224L368 320L424 320C430.5 320 436.3 323.9 438.8 329.9C441.3 335.9 439.9 342.8 435.3 347.3L331.3 451.3C325.1 457.5 314.9 457.5 308.7 451.3z"/>
              </svg>
              Download Curriculum
            </button>

            {/* Talk to Career Counsellor */}
            <a
              href="/demopage"
              className="flex items-center justify-center gap-2 bg-transparent border-2 border-[#151595] text-[#151595] font-semibold px-6 py-3 rounded-lg hover:bg-[#151595] hover:text-white transition shadow-md hover:shadow-lg transform hover:scale-105 shadow-blue-900/50 mb-4 sm:mb-0"
            >
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M8 5v14l11-7z" />
  </svg>
  Join Free Demo Session
</a>
          </div>
        </div>

      </div>
    </section>
  );
}

export default HeroSection;
